 import {
    Message
} from 'element-ui';
let messageInstance = null;
const resetMessage = (options) => {
    if(messageInstance) {
        messageInstance.close()
    }
    messageInstance = Message(options)
};
['error','success','info','warning'].forEach(type => {
    resetMessage[type] = options => {
        if(typeof options === 'string') {
            options = {
                message:options
            }
            options.duration = 1000;
            options.offset = 3;
            if (type == 'warning' || type == 'error') {
                options.duration = 1500
                options.showClose = true
            }

        }
        options.type = type
        return resetMessage(options)
    }
})
export const message = resetMessage


// WEBPACK FOOTER //
// ./src/assets/unit/message.js